export default __webpack_public_path__ + "static/pool_safety2-eb9c00c5c1a7502c7150ef09c3479cfb.jpg";